import React from 'react';
import './AiView.scss';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { injectIntl } from 'react-intl';
import * as actions from "store/actions/index";
import * as AiTypes from "Flow2/components/Ai/AiTypes/AiTypes";

class AiView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: []
        }
    }

    initData = () => {
        let faces;
        if (this.props.clip && this.props.clip.metadata && this.props.clip.metadata.compreface) {
            try {
                let aidata = JSON.parse(this.props.clip.metadata.compreface);
                if (aidata && aidata.cfrecognize) {
                    faces = aidata.cfrecognize;
                    this.setState({ data: faces });
                }

            } catch (e) {
                console.log("LOGS: getFaceData ERROR", e);
            }
        }
    }

    showPosition = (item) => {
        let pos = "";
        if (item && item.box) {
            if (item.box.x_min) pos += "x_min: " + item.box.x_min + ";";
            if (item.box.y_min) pos += " y_min: " + item.box.y_min + ";";
            if (item.box.x_max) pos += " x_max: " + item.box.x_max + ";";
            if (item.box.y_max) pos += " y_max: " + item.box.y_max + ";";
        }

        return pos;
    }


    showOcr = () => {
        let ocr;
        if (this.props.clip && this.props.clip.metadata && this.props.clip.metadata.ocr) {
            ocr = this.props.clip.metadata.ocr;
            return (
                <div className="aiview-tesseractbox">
                    <pre className="aiview-ocr">{ocr}</pre>
                </div>
            );
        }
    }

    showFaces = () => {
        return (
            <div className="aiview-box">
                <div className="aiview-content">
                    <div className="aiview-content-header">
                        {AiTypes.AI_FACES_TABLE_HEADER.map((item, idx) => {
                            return (
                                <div className="aiview-content-header-td">
                                    <span className="aiview-content-header-icon">
                                        <FontAwesomeIcon icon={item.icon} />
                                    </span>
                                    <div key={`aiViewHeader${idx}`}>{item.name}</div>
                                </div>
                            )
                        })}
                    </div>
                    {this.state.data.map((item, idx) => (
                        <div className="aiview-content-row" key={`aiViewRow${idx}`}>
                            <div>{item.subjects[0].subject}</div>
                            <div>{(item.box && item.box.probability) && item.box.probability}</div>
                            <div>{this.showPosition(item)}</div>
                        </div>
                    ))}

                </div>
            </div>
        )
    }

    componentDidMount = () => {
        this.initData();
    }

    render() {
        return (
            <div className="AiView">
                {this.props.isFaces && this.showFaces()}
                {this.props.isOcr && this.showOcr()}
            </div>
        );
    }
}

const mapStateToprops = (state) => ({
    aiObjects: state.ai.aiObjects,
    clip: state.clip.currentClip,
})
const mapDispatchToProps = (dispatch) => ({
    updateAiObjects: (obj) => dispatch(actions.updateAiObjects(obj)),
})

export default connect(mapStateToprops, mapDispatchToProps)(injectIntl(AiView));